/* Copyright (c) 2017 Backpack Health LLC */
/* global document */

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class ContentFrame extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      mounted: false,
    };
  }

  componentDidMount() {
    if (this.props.autoHeight) {
      this.setState({ mounted: true });
    }
  }

  calculateAutoHeight() {
    const appHeader = document.getElementById('cmp-app-header');
    return appHeader ? {
      height: `calc(100% - ${appHeader.clientHeight}px)`,
    } : null;
  }

  render() {
    const props = this.props;

    return (
      <div
        className={classnames(
          'cmp-application-frame--content bkgd-color-csAppBGgray',
          props.className
        )}
        style={props.autoHeight ? this.calculateAutoHeight() : null}
      >
        <div className="cmp-application-frame--content-area">
          {props.children}
        </div>
      </div>
    );
  }
}

ContentFrame.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  autoHeight: PropTypes.bool,
};

export default ContentFrame;
